<template>
  <div :class="classes">
    <div class="removable-entry__text">
      <slot />
    </div>
    <button
      id="remove-entry"
      class="removable-entry__hide"
      :aria-label="$t('chatbot.removeFile')"
      @click="$emit('close')"
    >
      <close-icon aria-labelledby="remove-entry" />
    </button>
  </div>
</template>

<script>
// @flow

import CloseIcon from '../../Icons/CloseIcon.vue'

export default {
  components: {
    CloseIcon
  },
  props: {
    truncate: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'removable-entry': true,
        'removable-entry--truncate': this.truncate,
        'removable-entry--bold': this.bold,
        [`removable-entry--${this.color}`]: !!this.color
      }
    }
  }
}
</script>

<style src="./removable-entry.scss" />
